import { Component, Input, OnInit } from '@angular/core';
import { SearchInputDetail } from '../../models/components';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit {

  @Input() text: string;
  @Input() primary: boolean;
  @Input() detail: Partial<SearchInputDetail>;
  @Input() type:
    'default' |
    'outline' |
    'primary';

  constructor() {
    this.text = '';
    this.primary = false;
    this.type = 'default';
    this.detail = {};
  }

  ngOnInit(): void {
  }

}
